import React , { Component } from 'react'
import LoginThirdBtn from "../LoginThirdBtn";
import tipAlert from "../BsyAlertTip/Staticize";
import './index.css'
import ssoImg from '../../images/ic_dandiandenglu@2x.png'
import i18n from "i18next";


export default class LoginSSO extends Component{
    constructor(props) {
        super(props);
        this.state={
            errMsg:'',
            errorInput:false,
            hasImgCode:window.data_config.vercode,
            ...props.customLoginConfig
        }
    }

    imgCodeValue = (ref) =>{
        this.imgCode = ref
    }

    componentDidMount() {
        const el = document.getElementsByClassName("LoginSSO")[0];
        el.addEventListener("keyup", (event) =>{
            if(event.keyCode === 13){
                this.accountPasswordLogin()
            }
        })
    }

    componentWillUnmount() {
        const el = document.getElementsByClassName("LoginSSO")[0]
        el.removeEventListener("keyup",null)
    }

    render() {
        const {remberPassword, hasImgCode, errMsg, errorInput, lang, remberPasswordShow, siteName, corpLogoImageUrl, corpLogoSwitch} = this.state
        const {rightTitle, changeContModePage, isMirror, isCorp, customLoginConfig} = this.props;
        const modeBtnShow={
            dingdingShow:true,
            workWechatShow:true,
            qyWechatShow:true,
            feishuShow:true,
            qyzjWechatShow:true,
            wechatShow:true,
            LoginAccountPasswordShow: true,
            LoginCodeShow: true,
            ssoShow: false,
        }
        return (
            <div className="LoginSSO">
                <div className="loginContentBox">
                    <div className="modeBtn"><img src={ssoImg} alt=""/></div>
                    <a href={window.data_config.ssourl} target='_blank'><span>{React.language('account.signin.sso')}</span></a>
                </div>
                <LoginThirdBtn customLoginConfig={customLoginConfig} isCorp={isCorp} modeBtnShow={modeBtnShow} changeContModePage={changeContModePage} />
            </div>
        );
    }
}


